<template>
  <div>
    <CCard>
      <CCardBody>
        <h2 class="text-center">Bienvenid@</h2>
        <div class="d-flex justify-content-between align-items-start">
          <div class="col-12 text-center justify-content-center">
            <div>
              <label for="">Para poder ver los cotizadores tienes que dar click en las opciones del menú izquierdo</label>
            </div>
            
            <br/>
            <div>
              <img src="img/latinizando.jpg" alt="Loading Icon">
            </div>
            <!--<button
              class="btn btn-success start mr-3"
              v-on:click="startRecording"
            >
              Presiona para grabar
            </button>
            <button class="btn btn-danger stop" v-on:click="stopRecording">
              Presiona para detener
            </button>-->
          </div>
        </div>
        <div class="d-flex justify-content-between mt-5">
          <div class="col-12">
            <!--<label for="">Texto a leer</label>
            <textarea
              name=""
              id="textToRead"
              style="border: 1px solid gray; height: 400px"
              class="p-2 form-control"
            ></textarea
            >-->
          </div>
          <!--<div class="col-6">
            <label for="">Resultado</label>
            <textarea
              name=""
              id="speechResult"
              style="border: 1px solid gray; height: 400px"
              class="p-2 form-control"
            ></textarea>
          </div>-->
        </div>

        <!--<div class="col-12 mt-3 alert alert-success" v-if="speechMatch == 1">
          Coincide
        </div>
        <div
          class="col-12 mt-3 alert alert-danger"
          v-else-if="speechMatch == 0"
        >
          No coincide
        </div>
        <div
          class="col-12 mt-3 alert alert-warning"
          v-else-if="speechMatch == 2"
        >
          No te escuché bien, vuelve a intentarlo
        </div>-->
      </CCardBody>
    </CCard>
   <!-- <CCard>
        <CCardBody style="min-height: 400px">
            <Photo
              ref="photo"
              @shot="handleShot"
            />
            <button class="btn btn-primary mt-3" @click="shotAgain">Tomar de nuevo</button>
            <button class="btn btn-outline-danger mt-3" @click="stopCamera">Detener cámara</button>
        </CCardBody>
    </CCard>
    <CCard>
        <CCardBody>
           <localizacion /> 
        </CCardBody>
    </CCard>
    <CCard>
      <CCardBody>
        <h1 class="text-center">Firma</h1>
        <Signature />
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <h1 class="text-center">Subir y convertir imágenes a base64</h1>
        <ImageUpload
          :multiple="false"
          v-on:upload="handleUploadImage"
          v-on:cancel="handleCancelUpload"
        />
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <h1 class="text-center">Subir y convertir documentos a base64</h1>
        <DocUpload 
          :multiple="false"
          @uploaded="handleUploadDoc"
        />
      </CCardBody>
    </CCard>

    <CCard>
      <CCardBody>
        <form @submit="handleSubmit">
          <div class="form-group">
            <label for="">Nombre</label>
            <input type="text" name="nombre" class="form-control">
          </div>
          <div class="form-group">
            <label for="">Apellidos</label>
            <input type="text" name="app" class="form-control">
          </div>
          <div class="form-group">
            <label for="">correo</label>
            <input type="email" name="email" class="form-control">
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary">Enviar</button>
          </div>
        </form>
      </CCardBody>
    </CCard>-->

    
  </div>
</template>

<script>
// Components
import Localizacion from '../../componentes/Location/Localizacion.vue'
import Signature from '../../componentes/Signature'

import Photo from '../../componentes/WebCam/Photo.vue'
import ImageUpload from "../../componentes/Uploads/Image.vue";
import DocUpload from '../../componentes/Uploads/DocUpload.vue';

// Helper
import { form } from '../../assets/helpers'


export default {
    components:{
        Localizacion,
        Signature,
        Photo,
        ImageUpload,
        DocUpload
    },
  data: function () {
    return {
      recognition: Object,
      speechMatch: Number,
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      console.log( form.build( e.target ) )
    },
    handleShot(base64) {
      console.log(base64);
    },
    handleUploadImage(base64) {
      this.replaceImage = 1;
      this.mySnap = base64;
    },
    handleCancelUpload() {
      console.log("Foto cancelada");
    },
    handleUploadDoc(base64) {
      console.log("El doc en base64", base64);
    },
    shotAgain() {
      this.$refs.photo.onStart();
    },
    stopCamera() {
      this.$refs.photo.onStop();
    },

    startRecording(e) {
      const speech = webkitSpeechRecognition;
      this.recognition = new speech();
      this.recognition.start();
    },
    stopRecording(e) {
      this.recognition.stop();

      this.recognition.onresult = function (e) {
        document.querySelector("#speechResult").value =
          e.results[0][0].transcript;

        // Compare texts
        let textToRead = document.querySelector("#textToRead").value; //.replaceAll(",", "");
        textToRead = textToRead.toLowerCase();
        textToRead = textToRead.trim();
        textToRead = textToRead.replaceAll(",", "");
        textToRead = textToRead.replaceAll(".", "");

        let speeched = document.querySelector("#speechResult").value;
        speeched = speeched.toLowerCase();
        speeched = speeched.trim();
        speeched = speeched.replaceAll(",", "");
        speeched = speeched.replaceAll(".", "");

        if (textToRead == speeched) {
          // this.speechMatch = 1;
          alert("Coincide");
        } else {
          // this.speechMatch = 0;
          alert("no Coincide");
        }
      };

      //   this.recognition.onspeechend

      this.recognition.onnomatch = function () {
        //   this.speechMatch = 2;
        alert("No entendí");
      };
      this.recognition.onerror = function () {
        //   this.speechMatch = 2;
        alert("No entendí");
      };
    },
  },
};
</script>